import DeliveryService from "../DeliveryService";

const Membership = {
  formData(data) {
    let form = new FormData();
    for (let obj in data) {
      form.append(obj, data[obj]);
    }
    return form;
  },
  earn(data) {
    return DeliveryService.post(`/console/member/add-point`, data);
  },
  searchRedemption(data) {
    return DeliveryService.post(`/console/member/redeem/verify`, data);
  },
  acceptRedemption(data) {
    return DeliveryService.post(`/console/member/redeem/approve`, data);
  },
};

export default Membership;
